module.exports = __webpack_public_path__ + "img/phil-smc.dd1b5bc2.jpg";